module.exports = __webpack_public_path__ + "static/media/five.689497e8.svg";